/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SeleTime.css';
import Calendar from './../Calendar'
import moment from 'moment'

class SeleTime extends React.Component {

  constructor(props){
    super(props)
    this.state={
      time:null,
      active:0,
      isCalendarCon:false,
      isShow:false,
      selectTime: '',
      
    }
    this.changeSelecPeriod = this.changeSelecPeriod.bind(this)
    this.enCalendarCon=this.enCalendarCon.bind(this)
    this.ovCalendarCon=this.ovCalendarCon.bind(this)
    this.openCalendar = this.openCalendar.bind(this)
    this.closeCalendar = this.closeCalendar.bind(this)
  }

  componentWillMount() {
    // console.log(moment().format('a'))
    if(this.state.selectTime==''&&!this.props.canOnchangeDate){
			if(moment().format('a')=='pm'){
        this.setState({selectTime:`${moment().subtract(0,'days').format('YYYY-MM-DD')}`})
      }else{
        this.setState({selectTime:`${moment().subtract(1,'days').format('YYYY-MM-DD')}`})
      }
		}
  }

  enCalendarCon=()=>{
    this.setState({
        isCalendarCon:true
    })
  }
  ovCalendarCon=()=>{
      this.setState({
          isCalendarCon:false
      })
  }
  openCalendar() {
      this.setState({
          isShow: !this.state.isShow,
          // selectTime:ss
      })
  }
  changeSelecPeriod = (index,nextTime) => {
      
     
     
      

      
  }
  closeCalendar(ss) {
      this.setState({
          isShow: false,
          selectTime: ss
      })
      this.changeSelecPeriod(this.state.periodIndex,ss)
      this.props.topTime(ss)
  }

  render() {

    const {selectTime,isCalendarCon}=this.state
    const {canOnchangeDate}=this.props

    return(
      <div className={s.root}>

        <div className={s.timeItem} onBlur={()=>!isCalendarCon?this.setState({isShow:false}):null}  tabIndex='0'>
          <span className={s.timeInfoTxt}></span>
          <div className={s.month} onClick={this.openCalendar}>
              <i className={s.monthIcon}></i>
              
              {canOnchangeDate?
              <input value={selectTime} onBlur={(e)=>this.props.topTime(e.target.value)} onChange={(e)=>this.setState({selectTime:e.target.value})} className={s.inputBox} />
              :<span className={s.monthTxt} >{selectTime}</span>}
          </div>
          <Calendar  isShow={this.state.isShow} close={this.closeCalendar} cycle='日榜'
              en={this.enCalendarCon}   ov={this.ovCalendarCon}
          />
        </div>

      </div>
    )


   
  }
}

export default withStyles(s)(SeleTime);



// WEBPACK FOOTER //
// src/components/SeleTime/SeleTime.js